import SkillsArray from "../../mainTabs/profile/SkillsArray";
import JobInfoRow from "../components/JobInfoRow";


export interface JobAssessmentResponse {
    "Overall Fit Assessment": string;
    "Detailed Fit Assessment": {
        emoji: string;
        category: string;
        explanation: string;
    }[];
}

export interface JobSummaryResponse {
    "Job Summary": string;
    "Fit Summary": {
        "Role Fit": string;
    };
}

export interface FullJobSummaryResponse {
    "Job Summary": string;
    "Fit Summary": {
        "Role Fit": string;
    };
    "Overall Fit Assessment": string;
    "Detailed Fit Assessment": {
        emoji: string;
        category: string;
        explanation: string;
    }[];
}

export const createFullResponse = (js: JobSummaryResponse, ja: JobAssessmentResponse): FullJobSummaryResponse => {
    return {
        "Job Summary": js["Job Summary"],
        "Fit Summary": js["Fit Summary"],
        "Overall Fit Assessment": ja["Overall Fit Assessment"],
        "Detailed Fit Assessment": ja["Detailed Fit Assessment"]
    }
}

export const JobSummaryWidget = (js: JobSummaryResponse, skills: string[]) => {
    return (
        <>
            <JobInfoRow key={0} title="Job Summary" subtitle={js["Job Summary"]} />
            <JobInfoRow key={1} title={'Skills'} subtitle={<div style={{ marginTop: '7px' }}><SkillsArray emptyStateText="" skills={skills} title='' allSelected={false} /></div>} hideTopBorder />
            <JobInfoRow key={2} title="Fit Score" subtitle={js["Fit Summary"]["Role Fit"]} />
        </>
    );
}

export const JobAssessmentWidget = (js: JobAssessmentResponse) => {
    console.log("JobAssessmentWidget", JSON.stringify(js));
    return (
        <>
            <JobInfoRow key={3} title="Fit Assessment" alwaysExpanded={true} subtitle={
                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '0px', marginTop: '6px' }}>
                    {js["Overall Fit Assessment"]}
                    <ul style={{
                        display: 'flex', flexDirection: 'column', paddingLeft: '0px', marginTop: '24px'
                    }}>
                        {js["Detailed Fit Assessment"].map((d, index) => (
                            <li key={index} style={{ paddingBottom: '12px' }}>
                                {d.emoji} <strong>{d.category}</strong>: {d.explanation}
                            </li>
                        ))}
                    </ul>
                </div>
            } />
        </>
    );
}
